import type { ShopOrderStatus, ShopPaymentMethod, ShopPaymentStatus } from "../../api/shop";
import type { TagTone } from "../../ui";

export const ONE_SIZE = "One size";

export const formatAmount = (n: number) =>
  Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatEGP = (n: number) => `${formatAmount(n)} EGP`;

const cairoDateTimeFmt = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
  timeZone: "Africa/Cairo",
});

export const fmtCairoDateTime = (v: string | null | undefined) => (v ? cairoDateTimeFmt.format(new Date(v)) : "-");

export const ORDER_STATUS_LABELS: Record<ShopOrderStatus, string> = {
  Placed: "Placed",
  ReadyForPickup: "Ready for pickup",
  Collected: "Collected",
  Cancelled: "Cancelled",
};

export const PAYMENT_STATUS_LABELS: Record<ShopPaymentStatus, string> = {
  Unpaid: "Unpaid",
  AwaitingReview: "Awaiting review",
  Paid: "Paid",
  Refunded: "Refunded",
  RefundDue: "Refund due",
};

export const PAYMENT_METHOD_LABELS: Record<ShopPaymentMethod, string> = {
  Balance: "Wallet",
  Fawry: "Fawry",
  InstaPay: "InstaPay",
  Cash: "Cash",
};

// Tag tone per state: paid / collected = ok, waiting = warn, cancelled / refund due = danger.
export const ORDER_STATUS_TONE: Record<ShopOrderStatus, TagTone> = {
  Placed: "warn",
  ReadyForPickup: "info",
  Collected: "ok",
  Cancelled: "danger",
};

export const PAYMENT_STATUS_TONE: Record<ShopPaymentStatus, TagTone> = {
  Unpaid: "neutral",
  AwaitingReview: "warn",
  Paid: "ok",
  Refunded: "info",
  RefundDue: "danger",
};

// A sport's tag colour, as on the tournament pages: padel blue, volleyball orange, beach volleyball yellow
export const sportTone = (name?: string): TagTone => {
  const t = (name || "").toLowerCase();
  if (t.includes("beach volleyball")) return "yellow";
  if (t.includes("padel")) return "brand";
  if (t.includes("volleyball")) return "spark";
  return "neutral";
};
